// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:export {
  primaryColor: #007796;
  errorColor: #d9001b;
  warningColor: #f59a23;
  successColor: #63a103;
  backgroundColor: #272524;
}

.MuiInputBase-root.snapshot-name .MuiOutlinedInput-notchedOutline {
  border: none;
}
.MuiInputBase-root svg {
  color: #fff;
}
.MuiInputBase-root .MuiSelect-select {
  padding: 0.4rem 2rem 0.4rem 1rem;
  min-width: 4rem;
  color: #fff;
  border-color: #363433;
  background-color: #363433;
}

.MuiPopover-root .MuiPaper-root {
  background-color: initial;
}
.MuiPopover-root .MuiPaper-root .MuiList-root {
  background-color: #363433;
  color: #fff;
  font-size: 12px;
}
.MuiPopover-root .MuiPaper-root .MuiList-root .Mui-selected,
.MuiPopover-root .MuiPaper-root .MuiList-root .Mui-selected:hover {
  background-color: #00538a;
}`, "",{"version":3,"sources":["webpack://./src/styles/colors.module.scss","webpack://./src/components/Elements/selectElement.scss"],"names":[],"mappings":"AA2BA;EACE,qBA5Bc;EA6Bd,mBA5BY;EA6BZ,qBA5Bc;EA6Bd,qBA5Bc;EA6Bd,wBA5BiB;ACEnB;;AAHE;EACE,YAAA;AAMJ;AAHE;EACE,WDGyB;ACE7B;AAFE;EACE,gCAAA;EACA,eAAA;EACA,WDHyB;ECIzB,qBDH2B;ECI3B,yBDN+B;ACUnC;;AAAA;EACE,yBAAA;AAGF;AADE;EACE,yBDd+B;ECe/B,WDdyB;ECezB,eAAA;AAGJ;AADI;;EAEE,yBDxB8B;AC2BpC","sourcesContent":["$primary-color: #007796;\n$error-color: #d9001b;\n$warning-color: #f59a23;\n$success-color: #63a103;\n$background-color: #272524;\n$background-color-opacity: rgba(29, 26, 25, 0.85);\n$button-contained-background-color: #00538a;\n$button-contained-text-color: #fff;\n$button-contained-border-color: #00538a;\n\n$button-outlined-background-color: #363433;\n$button-outlined-text-color: #fff;\n$button-outlined-border-color: #363433;\n\n$icon-color: #919191;\n$svg-color: #cdcccc;\n$badge-color: #e04545;\n\n$input-background-color: #1d1a19;\n$table-odd-row-background-color: #1d1a19;\n\n$text-color: #d7d6d6;\n$text-color-light: #282929;\n$link-color: #02a4ff;\n$border-color: #1d1a19;\n\n\n:export {\n  primaryColor: $primary-color;\n  errorColor: $error-color;\n  warningColor: $warning-color;\n  successColor: $success-color;\n  backgroundColor: $background-color;\n}","@use \"../../styles/colors.module.scss\" as *;\n\n.MuiInputBase-root {\n  &.snapshot-name .MuiOutlinedInput-notchedOutline {\n    border: none;\n  }\n\n  svg {\n    color: $button-outlined-text-color;\n  }\n\n  .MuiSelect-select {\n    padding: .4rem 2rem .4rem 1rem;\n    min-width: 4rem;\n    color: $button-outlined-text-color;\n    border-color: $button-outlined-border-color;\n    background-color: $button-outlined-background-color;\n  }\n}\n\n.MuiPopover-root .MuiPaper-root {\n  background-color: initial;\n\n  .MuiList-root {\n    background-color: $button-outlined-background-color;\n    color: $button-outlined-text-color;\n    font-size: 12px;\n\n    .Mui-selected,\n    .Mui-selected:hover {\n      background-color: $button-contained-background-color;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
